import {Component} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Sounds} from '../enums/Sounds.js';
import {AudioDirector} from './audio-director.js';

/**
 * Plays a one-off sound effect.
 * This is used when spawning in prefabs. Make sure it's not active on the prefab,
 * so it gets activated when the prefab is spawned.
 */
export class PlayOneOffSFX extends Component {
    static TypeName = 'play-one-off-SFX';

    @property.enum(Object.keys(Sounds).filter((e) => isNaN(Number(e))))
    soundFX: Sounds;

    start() {
        AudioDirector.instance.playOneShot(this.soundFX, true);
    }
}
